import { CALL_API_METHODS } from "repoV2/constants/apis";
import { callApi } from "repoV2/utils/common/api/callApi";
import { logError } from "repoV2/utils/common/error/error";
import { PART_PAYMENT_APIS } from "./api";

export const callGetInstalmentsDetails = async ({
    listingUuid,
    discountCode: discount_code,
    currency,
    appliedCount: applied_count,
}: {
    listingUuid: string;
    currency?: string;
    discountCode?: string;
    appliedCount?: number;
}) => {
    try {
        const response = await callApi({
            url: PART_PAYMENT_APIS.instalments_details({ listingUuid }),
            method: CALL_API_METHODS.GET,
            params: { discount_code, applied_count, currency },
            extraOptions: { appendExlyBackendHeaders: true },
        });
        return response.data.data.installments;
    } catch (error) {
        logError({
            error,
            occuredAt:
                "src/components/eventPage/components/PaymentPlan/api/apiCalls.ts",
            when: "calling callGetInstalmentsDetails",
        });
        throw error;
    }
};
